import React, { createContext } from 'react';
import { app } from '../config/firebase';

export const FirebaseAppContext = createContext();

export const FirebaseAppProvider = (props) => {
	return (
		<FirebaseAppContext.Provider value={app}>
			{props.children}
		</FirebaseAppContext.Provider>
	);
};
